import AboutUsMain1x from "domains/about/images/intro/aboutus_main.png";
import AboutUsMain2x from "domains/about/images/intro/aboutus_main@2x.png";
import AboutUsMain3x from "domains/about/images/intro/aboutus_main@3x.png";

export const AboutUsMainImageSet = [AboutUsMain1x, AboutUsMain2x, AboutUsMain3x];
